// UI learning only: no customer data, mutations or server-side progress.
export interface GuideStorage { getItem(key: string): string | null; setItem(key: string, value: string): void }
const visit = new Set<string>()
export function guideMemory(identity: string, storage: () => GuideStorage) {
  const key = (step: string): string => `roundly:messages-guide:v1:${identity}:${step}`
  return {
    seen(step: string): boolean {
      if (visit.has(key(step))) return true
      try { return storage().getItem(key(step)) === '1' } catch { return false }
    },
    complete(step: string): void {
      visit.add(key(step))
      try { storage().setItem(key(step), '1') } catch { /* Remember for this visit when storage is unavailable. */ }
    },
  }
}
